var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { mergeQueryString, updateSearch } from 'bernie-core';
import { parse } from 'query-string';
import { getFilteredObjectKeys } from './common-helper';
import { buildMicroMessage } from '../mappers/analytics-store';
import { FILTER_URL_PARAM_PREFIX } from '../stores';
var REGION_HOTEL = 'hotel';
export function trackSrpTileClick(activity, index, analytics) {
  var allActivityProducts = buildMicroMessage('allActivityProducts', {
    numOfProducts: 1,
    activityProducts: [{
      productId: parseInt(activity.id, 10),
      sortPosition: index + 1
    }]
  });
  if (activity.clientSideAnalytics) {
    analytics.trackEvent(activity.clientSideAnalytics.referrerId, activity.clientSideAnalytics.linkName, analytics.omnitureData, null, true, [allActivityProducts]);
  }
}
export function updateSearchQueryString(searchCriteriaStore, history, location) {
  if (searchCriteriaStore && !searchCriteriaStore.isQueryStringUpdated) {
    searchCriteriaStore.isQueryStringUpdated = true;
    var searchQuery = searchCriteriaStore.searchQuery;
    var queryParams = parse(location.search);
    if (searchQuery && searchCriteriaStore.isQueryKeysDifferent(queryParams)) {
      updateSearch({
        history: history,
        location: location,
        newParams: searchQuery,
        newState: {},
        replace: true
      });
    }
  }
}
function getRegionDetails(activitySearchStore) {
  var regionType = activitySearchStore.query && activitySearchStore.query.regionType === REGION_HOTEL || null;
  var resolvedRegion = activitySearchStore.searchSummary && activitySearchStore.searchSummary.resolvedRegion;
  var queryLocation = activitySearchStore.query ? activitySearchStore.query.location : '';
  return {
    regionName: regionType && queryLocation || resolvedRegion && resolvedRegion.fullRegionName || queryLocation,
    regionId: regionType && activitySearchStore.query.rid || resolvedRegion && resolvedRegion.regionId || '',
    __typename: 'ActivityRegion'
  };
}
export function updateSearchCriteriaStore(searchCriteriaStore, activitySearchStore, query) {
  var searchSummary = activitySearchStore.searchSummary;
  var searchedDates = searchSummary && searchSummary.dateValidationResult;
  var swpApplied = query.swp !== 'off';
  var isoStartDate = searchedDates && searchedDates.formattedStartDate || '';
  var isoEndDate = searchedDates && searchedDates.formattedEndDate || '';
  var _a = getRegionDetails(activitySearchStore),
    regionName = _a.regionName,
    regionId = _a.regionId;
  var filterKeys = getFilteredObjectKeys(query, FILTER_URL_PARAM_PREFIX);
  var filterParams = {};
  filterKeys.forEach(function (filterKey) {
    filterParams[filterKey] = query[filterKey];
  });
  searchCriteriaStore.searchQuery = __assign(__assign({}, filterParams), {
    location: regionName || '',
    sort: query.sort,
    slimSearchKeyword: query.slimSearchKeyword,
    swp: swpApplied ? 'on' : 'off',
    startDate: isoStartDate,
    endDate: isoEndDate,
    rid: regionId,
    selectedId: query.selectedId,
    mctc: query.mctc,
    travelDurationFromHotelEnabled: query.travelDurationFromHotelEnabled,
    regionType: query.regionType,
    latLong: query.latLong,
    landingPage: query.landingPage
  });
}
export function handlePillsClick(history, location, selections, pageId, analytics, activitySearchStore, searchCriteriaStore, index, selectedFilters) {
  var _a, _b, _c;
  activitySearchStore.searchSetup();
  if (selections.length > 0) {
    selectedFilters.splice(index, 1);
    if (selectedFilters.length === 0) {
      searchCriteriaStore.pillRemoveIndex = -1;
    } else {
      searchCriteriaStore.pillRemoveIndex = index;
    }
    var queryParams = parse(location.search);
    var filterCategory = selections[0].id;
    if (filterCategory === 'slimSearchKeyword') {
      var slimSearchKeyword = queryParams && queryParams.slimSearchKeyword || '';
      if (slimSearchKeyword === selections[0].value) {
        analytics.trackEvent("LX.SR.Remove.Keyword.".concat(selections[0].value), 'keyword-pill-removed', analytics.omnitureData);
        updateSearch({
          history: history,
          location: location,
          newParams: {
            slimSearchKeyword: ''
          }
        });
      }
    } else {
      var filterCategoryKey = FILTER_URL_PARAM_PREFIX + filterCategory;
      var oldFiltersString = queryParams && queryParams[filterCategoryKey] || '';
      var filters_1 = oldFiltersString.split(',').filter(function (filter) {
        return filter !== '';
      });
      selections.forEach(function (selection) {
        var indexOfFilterToDelete = filters_1.indexOf(selection.value);
        if (indexOfFilterToDelete > -1) {
          filters_1.splice(indexOfFilterToDelete, 1);
        }
      });
      var filtersString = filters_1.join(',');
      var filterRemovedParamsQuery = mergeQueryString(location.search, (_a = {}, _a[filterCategoryKey] = filtersString === '' ? undefined : filtersString, _a));
      if (filterCategory === 'seeAll') {
        analytics.trackEvent('LX.SR.Remove.SeeAll', 'see-all-pill-removed', analytics.omnitureData);
        if (queryParams && queryParams.regionType) {
          updateSearch({
            history: history,
            location: location,
            newParams: (_b = {}, _b[filterCategoryKey] = filtersString, _b.sort = 'RECOMMENDED', _b.selectedId = '', _b.regionType = '', _b)
          });
        } else {
          updateSearch({
            history: history,
            location: location,
            newParams: (_c = {}, _c[filterCategoryKey] = filtersString, _c.sort = 'RECOMMENDED', _c.selectedId = '', _c)
          });
        }
      } else {
        analytics.trackEvent("LX.".concat(pageId, ".Remove.").concat(filterCategory, ".").concat(selections[0].value), "".concat(filterCategory, "-pill-removed"), analytics.omnitureData);
        updateSearch({
          history: history,
          location: location,
          newParams: filterRemovedParamsQuery,
          queryCombiner: function (prevQuery, nextQuery) {
            return nextQuery;
          }
        });
      }
    }
  }
}
export function getBreadcrumbUrl(history, location, selectionsToRemove) {
  var searchQueryString = history.location.search;
  var queryParams = parse(location.search);
  selectionsToRemove.forEach(function (selectionToRemove) {
    var _a;
    var _b;
    var key = selectionToRemove.id;
    var existingUrlFilterValues = queryParams && queryParams[key] ? (_b = queryParams[key]) === null || _b === void 0 ? void 0 : _b.split(',') : [];
    if (existingUrlFilterValues.length > 0) {
      selectionsToRemove.forEach(function (selection) {
        var indexOfUrlFilterToDelete = existingUrlFilterValues.indexOf(selection.value);
        if (indexOfUrlFilterToDelete > -1) {
          existingUrlFilterValues.splice(indexOfUrlFilterToDelete, 1);
        }
      });
      var updatedUrlFilterValues_1 = existingUrlFilterValues.length > 0 ? (_a = {}, _a[key] = existingUrlFilterValues.join(','), _a) : {};
      searchQueryString = mergeQueryString(searchQueryString, updatedUrlFilterValues_1, function (queryKey) {
        if (queryKey === key) {
          return Boolean(updatedUrlFilterValues_1[queryKey]);
        }
        return Boolean(queryParams[queryKey]);
      });
    }
  });
  return "".concat(location.pathname, "?").concat(searchQueryString);
}